<textarea id="{{elementId}}">{{content}}</textarea>